import type { SettingsTemplateModel } from '@/shared/generated'

import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

import {
	useSaveAsTemplateAction,
	useUseTemplateAction,
} from '@/features/settings-template-actions'

import { SettingsTemplateType } from '@/shared/generated'

export const useScenarioSettingActions = ({
	templateType,
}: {
	templateType: SettingsTemplateType
}) => {
	const { watch, setValue } = useFormContext()
	const { path, name } = useMemo(() => {
		switch (templateType) {
			case SettingsTemplateType.ScenarioBusinessConstraints:
				return {
					path: 'settings.business',
					name: 'business',
				}
			/* case SettingsTemplateType.ScenarioStrategy:
				return {
					path: 'settings.strategy',
					name: 'strategy',
				} */
			case SettingsTemplateType.ScenarioStopList:
				return {
					path: 'settings.stop_list',
					name: 'stop_list',
				}
			default:
				return {
					path: 'settings.strategy',
					name: 'strategy',
				}
		}
	}, [templateType])
	const handleUseTemplate = ({ body }: SettingsTemplateModel) => {
		setValue(path, body[name as keyof typeof body], {
			shouldDirty: true,
		})
	}
	const useTemplateAction = useUseTemplateAction({
		templateType,
		handler: handleUseTemplate,
	})
	const saveAsTemplateAction = useSaveAsTemplateAction({
		templatePayload: {
			name: watch('name'),
			template_type: templateType,
			body: {
				[name]: watch(path),
			},
		},
	})

	return useMemo(
		() => [useTemplateAction, saveAsTemplateAction],
		[useTemplateAction, saveAsTemplateAction]
	)
}
